import { useState, useEffect } from "react";

export const useUpdateSessionStorage = (key: string) => {
  const [offer, setOffer] = useState(() => {
    const sessionOffer = sessionStorage.getItem(key);
    return sessionOffer ? JSON.parse(sessionOffer) : null;
  });

  useEffect(() => {
    const handleUpdate = () => {
      const updatedValue = sessionStorage.getItem(key);
      setOffer(updatedValue ? JSON.parse(updatedValue) : null);
    };
    window.addEventListener("offerUpdate", handleUpdate);
    return () => window.removeEventListener("offerUpdate", handleUpdate);
  }, [key]);

  return [offer, setOffer];
};
